export const camel2title = (camelCase) => {
  const titleCase = camelCase
    .replace(/([A-Z]+)/g, ' $1')
    .replace(/([A-Z][a-z])/g, ' $1');
  return (
    titleCase.charAt(0).toUpperCase() + titleCase.slice(1).replace('.', ' ')
  );
};
